module.exports = __webpack_public_path__ + "static/media/img-02.fa700804.png";